<template>
  <div class="result-widget">
    <div class="result-widget-body">
      <template v-for="(item, index) in survey_result">
        <div
          class="survey-answer-widget"
          :key="index"
          v-if="item.section_type == 'question'"
        >
          <div class="survey-answer-header">
            <h1>{{ item.ask }}</h1>
          </div>
          <!-- For short answer -->
          <div
            v-if="item.question_type == 'short_answer'"
            class="survey-answer-body"
          >
            {{ item.answer }}
          </div>
          <!-- For long answer -->
          <div
            v-if="item.question_type == 'paragraph'"
            class="survey-answer-body"
          >
            {{ item.answer }}
          </div>
          <!-- For radio answer -->
          <div
            v-if="item.question_type == 'multiple_choice'"
            class="survey-answer-body"
          >
            <div
              class="radio-item"
              v-for="(option, option_index) in item.choice_options"
              :key="option_index"
            >
              <span>{{ option.name }}</span>
            </div>
          </div>
          <!-- For checkbox answer -->
          <div
            v-if="item.question_type == 'checkboxes'"
            class="survey-answer-body"
          >
            <div
              class="checkbox-item"
              v-for="(option, option_index) in item.choice_options"
              :key="option_index"
            >
              <span>{{ option.name }}</span>
            </div>
          </div>
          <!-- For checkbox answer -->
          <div
            v-if="item.question_type == 'dropdown'"
            class="survey-answer-body"
          >
            <div
              class="selected-item"
              v-for="(option, option_index) in item.choice_options"
              :key="option_index"
            >
              <span>{{ option.name }}</span>
            </div>
          </div>
          <!-- For file upload answer -->
          <div
            v-if="item.question_type == 'file_upload'"
            class="survey-answer-body"
          ></div>
          <!-- For date answer -->
          <div v-if="item.question_type == 'date'" class="survey-answer-body">
            <div class="date-item">
              {{ item.answer | formatDate }}
            </div>
          </div>
          <!-- For date answer -->
          <div v-if="item.question_type == 'time'" class="survey-answer-body">
            <div class="date-item">
              {{ item.answer }}
            </div>
          </div>
        </div>
        <div
          class="survey-answer-widget"
          :class="{ section_widget: item.section_type == 'section' }"
          :key="index"
          v-if="item.section_type == 'section'"
        >
          <h1>{{ item.title }}</h1>
          <p>{{ item.description }}</p>
        </div>
        <div
          class="survey-answer-widget"
          :class="{ title_widget: item.section_type == 'title' }"
          :key="index"
          v-if="item.section_type == 'title'"
        >
          <h2>{{ item.title }}</h2>
          <p>{{ item.description }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  props: {
    value: {
      type: String,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    survey_result() {
      return JSON.parse(this.value);
    },
  },
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    $isVideo(filename) {
      return /\.(webm|mp4|mkv)$/i.test(filename);
    },
    $isImage(filename) {
      return /\.(jpeg|jpe|jpg|gif|png|webp|svg)$/i.test(filename);
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.result-widget {
  width: 100%;
  .result-widget-body {
    .survey-answer-widget {
      border-bottom: 1px solid #ddd;
      margin-bottom: 20px;
      &.section_widget {
        border-bottom: 3px solid #ddd;

        h1 {
          font-size: 20px;
        }
      }

      &.title_widget {
        h2 {
          font-size: 18px;
        }

        p {
          font-size: 13px;
        }
      }

      .survey-answer-header {
        h1 {
          font-size: 16px;
          color: #000;
        }
      }

      .survey-answer-body {
        color: rgb(43, 42, 42);

        .radio-item {
          margin-bottom: 6px;

          &.active {
            color: #0884af;
            padding: 4px;
            border-left: 3px solid #0884af;
          }
        }

        .checkbox-item {
          margin-bottom: 6px;

          &.active {
            color: #0884af;
            padding: 4px;
            border-left: 3px solid #0884af;
          }
        }

        .uploaded-file-item {
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;

          .btn-download {
            background: #0884af;
            color: #fff;
            padding: 11px;
            border-radius: 5px;
            text-decoration: none;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>